import React, { Component } from 'react'
import PropTypes from 'prop-types'
import hoistNonReactStatics from 'hoist-non-react-statics'
import getInjector from './sagaInjector'

export default ({ key, saga, mode }) => WrappedComponent => {
  class InjectSaga extends Component {
    static WrappedComponent = WrappedComponent

    static contextTypes = {
      store: PropTypes.object.isRequired
    }

    static displayName = `withSaga(${WrappedComponent.displayName ||
      WrappedComponent.name ||
      'Component'})`

    state = {
      isInjected: false
    }

    componentDidMount() {
      const { injectSaga } = this.injectors
      injectSaga(key, { mode, saga }, this.props)
      this.setState({ isInjected: true })
    }

    injectors = getInjector(this.context.store)

    render() {
      const { isInjected } = this.state
      if (!isInjected) return null
      return <WrappedComponent {...this.props} />
    }

    componentWillUnmount() {
      const { ejectSaga } = this.injectors
      ejectSaga(key)
    }
  }

  return hoistNonReactStatics(InjectSaga, WrappedComponent)
}
